module.exports = __webpack_public_path__ + "static/media/BlueCircleBackground.e15623ed.png";